export default {
  computed: {
    hasNameSlots () {
      let result = []

      for(const [name, slot] of Object.entries(this.$scopedSlots)) {
        const [slotKey, slotName] = name.split('__')

        // 如果有slotName 则是具名插槽
        if(slotName) {
          result.push({
            slotKey,
            slotName
          })
        }
      }

      return result
    }
  }
}
